export default "__VITE_ASSET__DOQQP1AO__"